<h1 matDialogTitle>{{ data.title }}</h1>

<div>
    <mat-dialog-content>
        <div [innerHTML]="htmlContent"></div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button (click)="confirmAction(true)" color="{{data.buttonType}}">OK</button>
    </mat-dialog-actions>
</div>
